/**
 * OTP geri sayimi - SAF fonksiyonlar.
 *
 * "OTP gereken her yerde zaman asimi da olsun" gereksinimi burada yasiyor.
 * Kullanicinin gormesi gereken iki sey var:
 *
 *  1. **Kod ne zaman olecek** (15 dakika). Bunu gostermemek, sessizce
 *     gecersizlesen bir koda tekrar tekrar basan bir kullanici uretiyor ve
 *     hata mesaji ("Kod hatalı") gercek sebebi SOYLEMIYOR.
 *  2. **Yeniden gonderme ne zaman acilir** (60 saniye). Sunucu bu limiti
 *     zorluyor; butonu pasif gostermek 429'u bir arayuz durumuna ceviriyor.
 *
 * Saf tutulmasinin sebebi: zamanlayici mantigini test etmek icin fake timer
 * ve React render'i gerekmiyor - `now` disaridan veriliyor.
 */

/** Sunucunun yeniden gonderme siniri (`resend-code`: 1/60sn). */
export const RESEND_COOLDOWN_SECONDS = 60

export interface CodeClock {
  /** Kodun gecerliligi bitene kadar kalan saniye (0 = oldu). */
  remaining: number
  /** Yeniden gonderme acilana kadar kalan saniye (0 = acik). */
  resendIn: number
  expired: boolean
}

export function codeClock(input: {
  /** Kodun gonderildigi an (ms). */
  issuedAt: number
  /** Sunucudan gelen gecerlilik suresi (saniye). */
  ttlSeconds: number
  /** Simdi (ms). */
  now: number
}): CodeClock {
  const elapsed = Math.floor((input.now - input.issuedAt) / 1000)
  const remaining = Math.max(0, input.ttlSeconds - elapsed)
  return {
    remaining,
    resendIn: Math.max(0, RESEND_COOLDOWN_SECONDS - elapsed),
    expired: remaining === 0,
  }
}

/** `mm:ss`. Tek haneli saniye sifirla dolduruluyor. */
export function formatDuration(totalSeconds: number): string {
  const safe = Math.max(0, Math.floor(totalSeconds))
  const minutes = Math.floor(safe / 60)
  const seconds = safe % 60
  return `${minutes}:${String(seconds).padStart(2, '0')}`
}

/**
 * Kod alani icin dogrulama.
 *
 * Yalnizca 6 hane. Bosluk ve tire TEMIZLENIYOR: kullanicilar e-postadan
 * kopyalarken bosluk tasiyor ve "Kod hatalı" demek, gercekte dogru kodu
 * girmis birine yalan soylemek olurdu.
 */
export function normalizeOtp(value: string): string {
  return value.replace(/[\s-]/g, '').slice(0, 6)
}

export function isCompleteOtp(value: string): boolean {
  return /^\d{6}$/.test(normalizeOtp(value))
}

/**
 * Yedek kod normalizasyonu.
 *
 * Crockford base32 (`XXXXX-XXXXX`): buyuk harfe cevriliyor ve tire
 * kaldiriliyor, cunku kullanici kagittan okurken kucuk harf ve tireyi
 * degistirebiliyor. `I/L/O/U` alfabede YOK, o yuzden karakter degisimi
 * (`0`->`O` gibi) yapmiyoruz - yanlis bir kodu "duzeltmis" gibi gostermek
 * daha kotu.
 */
export function normalizeBackupCode(value: string): string {
  return value.toUpperCase().replace(/[\s-]/g, '')
}
